import { OtherPermission } from '../enums';
export function transformCollaboratorToApiField(permissionDetail) {
    return {
        patent: permissionDetail.patent,
        comment: permissionDetail.comment,
        field: permissionDetail.customField,
        folder_create: permissionDetail.others.includes(OtherPermission.FOLDER_CREATE),
        folder_edit: permissionDetail.others.includes(OtherPermission.FOLDER_EDIT),
        folder_copy: permissionDetail.others.includes(OtherPermission.FOLDER_COPY),
        folder_move: permissionDetail.others.includes(OtherPermission.FOLDER_MOVE),
        folder_delete: permissionDetail.others.includes(OtherPermission.FOLDER_DELETE),
        export: permissionDetail.others.includes(OtherPermission.EXPORT),
        assign: permissionDetail.others.includes(OtherPermission.ASSIGN),
    };
}
